import { UsuarioAlerta } from 'app/dto/usuario-alerta.dto';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { interval, Subject, Subscription } from 'rxjs';
import { StorageService } from 'app/service/storage.service';
import { AuthenticationService } from "app/auth/service/authentication.service";
import { Router } from "@angular/router";
import { AlertaUsuarioService } from "app/service/alerta-usuario.service";
import { MatDialog } from "@angular/material/dialog";
import { PosponerDialog } from "./posponer-notificacion/posponer-notificacion.component";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { ModalNotificacionesComponent } from "app/widgets/modal-notifiaciones/modal-notificaciones.component";
import { environment } from 'environments/environment';
import { FuncionService } from 'app/service/funcion.service';
import { Funcion } from 'app/dto/funcion.dto';
import { MasajearRolesComponent } from './masajear-roles/masajear-roles.component';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  modalNotificaciones: NgbModalRef;
  funciones: Funcion[];

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu = [{ title: 'Cerrar Sesión', data: { id: 'logout' } }];
  notificaciones: UsuarioAlerta[] = [];
  noLeidas = 0;
  mySub: Subscription;

  constructor(private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private userService: UserData,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private storageService: StorageService,
    private authenticationService: AuthenticationService,
    private alertaUsuarioService: AlertaUsuarioService,
    private router: Router,
    public dialog: MatDialog,
    private funcionService: FuncionService,
    private modalService: NgbModal) {
    // cada 60 segundos actualizo las notificaciones
    this.mySub = interval(60000).subscribe((func => {
      this.obtenerNotificaciones();
    }))
  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;

    this.user = JSON.parse(this.storageService.getItem('user'));

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

    this.menuService.onItemClick().subscribe((menuBag) => {
      console.log("--->");
      if (document.documentElement.clientWidth < 1206) {
        this.sidebarService.toggle(true, 'menu-sidebar');
        document.querySelector('.menu-sidebar').classList.remove("expand");
      }
      if (menuBag.item.data) {
        switch (menuBag.item.data.id) {
          case 'logout':
            this.logout();
            break;
          default:
        }
      }
    });

    this.obtenerNotificaciones();
  }

  amIRoot() {
    return this.user.usuario === 'root@root.com';
  }

  modalRoles: NgbModalRef;
  async masajearRoles() {
    await this.funcionService
      .findAll()
      .toPromise()
      .then((d) => (this.funciones = d));


    this.modalRoles = this.modalService.open(MasajearRolesComponent, {
      ariaLabelledBy: "modal-basic-title",
      size: "xl",
      centered: true
    });
    this.modalRoles.componentInstance.modalRef = this.modalRoles;
    this.modalRoles.componentInstance.funciones = this.funciones;

    this.modalRoles.result.then((comprobante2) => {
    }, (reason) => {
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.mySub.unsubscribe();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  logout() {
    this.authenticationService.logout().then(d =>
      this.router.navigate(['auth', 'login'])
    );
  }

  updateNotificacion(usuarioAlerta: UsuarioAlerta) {
    this.noLeidas = this.noLeidas - 1;
    this.alertaUsuarioService.update(usuarioAlerta.idUsuarioAlerta, usuarioAlerta).subscribe(d => { });
  }

  obtenerNotificaciones() {
    this.alertaUsuarioService.findAllNoLeidasByIdUsuario().subscribe(d => {
      this.noLeidas = d.length;
      this.notificaciones = d;
    });
  }

  openNotificacion(usuarioAlerta: UsuarioAlerta) {
    if (usuarioAlerta.fechaPospuesta) {
      usuarioAlerta.fechaPospuesta = null;
      this.updateNotificacion(usuarioAlerta);
    }
    this.marcarComoLeida(usuarioAlerta);
    if (usuarioAlerta.alerta.link) {
      this.router.navigate([usuarioAlerta.alerta.link]);
    }
  }

  marcarComoLeida(usuarioAlerta: UsuarioAlerta) {
    if (!usuarioAlerta.leido) {
      usuarioAlerta.leido = true;
      this.updateNotificacion(usuarioAlerta);
    }
  }

  posponer(usuarioAlerta: UsuarioAlerta) {
    const dialogRef = this.dialog.open(PosponerDialog, { data: { usuarioAlerta: usuarioAlerta } });
    dialogRef.afterClosed().subscribe(result => {
      this.obtenerNotificaciones();
    });
  }

  openTodas() {
    this.modalNotificaciones = this.modalService.open(ModalNotificacionesComponent, {
      ariaLabelledBy: 'modal-basic-title', size: 'xl', windowClass: 'custom-back'
    });
    this.modalNotificaciones.componentInstance.modalRef = this.modalNotificaciones;

    this.modalNotificaciones.result.then((stock) => {
    }, (reason) => {
    });
  }
}
